module.exports = __webpack_public_path__ + "assets/img/index_bg.ab22553a.png";